import { render } from "./BonusStat.vue?vue&type=template&id=da0ef43e"
import script from "./BonusStat.vue?vue&type=script&lang=js"
export * from "./BonusStat.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__